<template>
  <div class="download-app">
    <div class="download-app-cover" v-if="isCoverShow" @click="closeCover">
      <img src="../assets/images/download-app-cover.png" alt="">
    </div>
    <div class="download-app-main">
      <img src="../assets/images/download-app-1.png" alt="">
      <img src="../assets/images/download-app-2.jpg" alt="">
      <!--<img src="../assets/images/download-app-3.jpg" alt="">-->
      <div class="download-app-main-button" @click="download">
        <img src="../assets/images/download-app-button.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import os from '@edu-fe/os'

  export default {
    data () {
      return {
        isCoverShow: false,
        downloadList: {
          'tz1': 'https://hoplink.ksosoft.com/mlyc',
          'yyb11': 'https://hoplink.ksosoft.com/4pvj',
          'yyb10': 'https://hoplink.ksosoft.com/yaqj',
          'yyb9': 'https://hoplink.ksosoft.com/gs1g',
          'yyb8': 'https://hoplink.ksosoft.com/oxi0',
          'yyb7': 'https://hoplink.ksosoft.com/vhfp',
          'yyb5': 'https://hoplink.ksosoft.com/q4dx',
          'yyb4': 'https://hoplink.ksosoft.com/zqba',
          'yyb3': 'https://hoplink.ksosoft.com/fnb5',
          'yyb2': 'https://hoplink.ksosoft.com/nrgi',
          'yyb1': 'https://hoplink.ksosoft.com/qocb',
          'vc12_yyb1': 'https://staticedu.wps.cn/app/wpsedu_v1.3.2_vc_12_yyb1.apk'
        }
      }
    },
    computed: {
      type () {
        return this.$route.query.type
      },
      isIos () {
        return window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      }
    },
    methods: {
      closeCover () {
        this.isCoverShow = false
      },
      download () {
        if (os.type === 'weixin') {
          return this.isCoverShow = true
        }
        this.showCover()
      },
      showCover () {
        if (this.isIos) {
          return window.location.href = 'https://itunes.apple.com/app/apple-store/id1439039386?pt=38515&ct=wpsdownload&mt=8'
        }

        if (os.type === 'weixin') {
          // this.isCoverShow = true
        } else {
          if (this.downloadList[this.type]) {
            return window.location.href =this.downloadList[this.type]
          }
          window.location.href = 'https://staticedu.wps.cn/app/wpsedu_v1.3_vc_10_jinli.apk'
        }
      }
    },
    mounted () {
      this.showCover()
    },
    created () {
    },
    components: {

    }
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../style/main";

  .download-app {
    font-size: 0;
    &-cover {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      background-color: rgba(#000, .3);
      text-align: right;
      > img {
        width: rem(616);
      }
    }
    &-main {
      position: relative;
      width: 100%;
      > img {
        width: 100%;
      }
      &-button {
        position: fixed;
        bottom: rem(0);
        left: 50%;
        transform: translateX(-50%);
        > img {
          width: rem(600);
        }
      }
    }
  }
</style>
